export const NUMBER_REGEX = /^[0-9]*$/;
export const ALPAHBET_REGEX = /^[a-zA-Z ]*$/;
export const PHONE_NUMBER_REGEX = /^[0-9]{10}$/;
export const NON_INDIAN_PHONE_REGEX: RegExp = /^\+?[1-9]\d{6,13}$/;
export const LINKEDIN_REGEX =
  /^((http|https):\/\/)?(www\.)?([A-Za-z]+\.)?linkedin\.com\/(pub|in|profile)\/[^\/]+\/?$/u;
